import { render } from "./tableDetailCol.vue?vue&type=template&id=9cf5c8e8&scoped=true"
import script from "./tableDetailCol.vue?vue&type=script&lang=js"
export * from "./tableDetailCol.vue?vue&type=script&lang=js"

import "./tableDetailCol.vue?vue&type=style&index=0&id=9cf5c8e8&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf5c8e8"]])

export default __exports__